import BankAccountVerificationButton from "./BankAccountVerificationButton"

export default BankAccountVerificationButton
